<div>
    <hub-modal-header headerText="{{ 'bikeshop.job_actions.cancel_job' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">

    <div class="cancellation-reasons-container">
        <div class="cancellation-reason-title">{{ 'bikeshop.modal.update_job_card.job_card.select_a_cancellation_reason' | translate }}</div>
        <div *ngFor="let reason of cancellationReasons" class="cancellation-reason" (click)="reasonSelected(reason)" [ngClass]="{'selected': selectedReason?.value === reason.value}">
            <div>{{reason.label}}</div>
        </div>

        <div *ngIf="showOtherReason" class="other-cancellation-reason">
            <hub-input                
                label="{{ 'bikeshop.cancellation_reason.specify_reason' | translate }}"
                [(ngModel)]="otherCancellationReason"
            ></hub-input>
        </div>
    </div>
</div>
<div class="modal-footer-container">
    <div class="button-container">
        <hub-button [text]="'bikeshop.job_actions.cancel_job' | translate" (buttonClick)="cancelJobCard()" [disabled]="!canCancelJobCard() || cancellingJobCard" [loading]="cancellingJobCard"
            [style]="'secondary'" [size]="'xl'"></hub-button>
    </div>
</div>
